import { NavLink } from 'react-router-dom';
import './Sidebar.css';

export default function Sidebar({ isOpen }) {
  const links = [
    { name: 'Dashboard', path: '/dashboard', icon: '📊' },
    { name: 'Users', path: '/users', icon: '👤' },
    { name: 'Master', path: '/products', icon: '⚙️' },
    { name: 'Packaging', path: '/packagin-index', icon: '📦' },
    { name: 'MIN', path: '/material-issue-index', icon: '📄' },
    { name: 'MRN', path: '/material-return-index', icon: '📥' },
    { name: 'TC', path: '/test-certificate-index', icon: '🧪' },
  ];

  return (
    <aside className={`sidebar ${isOpen ? 'open' : 'collapsed'}`}>
      {links.map(link => (
        <NavLink
          key={link.path}
          to={link.path}
          className={({ isActive }) =>
            `sidebar-item ${isActive ? 'active' : ''}`
          }
        >
          <span className="icon">{link.icon}</span>
          {/* 🔥 Show text only when open */}
          {isOpen && <span className="text">{link.name}</span>}
        </NavLink>
      ))}
    </aside>
  );
}
